(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits-row.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits-row.js');
'use strict';

const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  IconText
} = svs.tb_ui_react.icon_text;
const {
  TRANSLATION
} = svs.accountservicesReact.deposit.depositLimits.constants;
const periodText = limitType => "Ins\xE4ttningsgr\xE4ns per ".concat(TRANSLATION.get(limitType === null || limitType === void 0 ? void 0 : limitType.toUpperCase()) || '');
const DepositLimitsRow = _ref => {
  let {
    limit
  } = _ref;
  const {
    currentDepositBudget,
    futureDepositBudget,
    limitType,
    nextTimeShift,
    currentDepositAmount
  } = limit;
  const remainingDepositBudget = (currentDepositAmount === null || currentDepositAmount === void 0 ? void 0 : currentDepositAmount.length) && "".concat(formatCurrency(Math.min(1000000, Math.max(0, parseInt(currentDepositBudget, 10) - parseInt(currentDepositAmount, 10)))), " kr");
  const isFutureBudget = nextTimeShift && currentDepositBudget !== futureDepositBudget;
  return React.createElement("div", {
    className: "u-border-bottom-1 border-grey-500 margin-bottom padding-v"
  }, React.createElement("div", {
    className: "f-medium u-flex"
  }, React.createElement("span", {
    className: "inline-block u-flex-grow-1 f-left"
  }, periodText(limitType)), React.createElement("span", null, "".concat(formatCurrency(currentDepositBudget) || '', " kr"))), React.createElement("div", {
    className: "fc-grey-600 u-flex"
  }, React.createElement("span", {
    className: "inline-block u-flex-grow-1 f-left"
  }, "Kvar att kunna s\xE4tta in"), React.createElement("span", null, remainingDepositBudget)), isFutureBudget && React.createElement("div", {
    className: "padding-bottom f-left"
  }, React.createElement(IconText, {
    size: "200"
  }, React.createElement("span", {
    className: "fc-grey-600"
  }, "Ny gr\xE4ns:", ' ', "".concat(formatCurrency(futureDepositBudget), " kr,\n             g\xE4ller fr\xE5n ").concat(dateFns.format(dateFns.parseISO(nextTimeShift), 'dd/MM HH:mm'))))));
};
svs.accountservicesReact.deposit.depositLimits.DepositLimitsRow = DepositLimitsRow;

 })(window);